import React from 'react';

const testIds = {
    CHEVRON_DOWN_ICON: 'CHEVRON_DOWN_ICON'
};

const ChevronDown = (props: any) => (
    <svg
        data-test-id={testIds.CHEVRON_DOWN_ICON}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.67658 6.1618L12 14.4852L20.3234 6.1618L22 7.83838L12 17.8384L2 7.83838L3.67658 6.1618Z"
            fill="#F9FAFA"
        />
    </svg>
);

export {ChevronDown};
